import { signInWithAuthentik, handleAuthentikCallback } from './authentik';
import { Application } from '../../core/app';

export function logout() {
    // Clear all auth state
    Application.logout();

    // Clear axios headers
    delete window.axios.defaults.headers.common['Authorization'];
    delete window.axios.defaults.headers.common['accessToken'];

    // Signal AuthProvider to clear user state (prevents redirect loop)
    window.dispatchEvent(new CustomEvent('authstatechange', { detail: 'logout' }));

    // Redirect to login
    setTimeout(() => { window.location.href = '/login'; }, 100);
}

export { signInWithAuthentik as signIn, handleAuthentikCallback as handleCallback };
